"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chunkableAsyncMap = void 0;
const lodash_1 = require("lodash");
async function chunkableAsyncMap(input, fn, concurrency) {
    const output = [];
    for (const inputChunk of (0, lodash_1.chunk)(input, concurrency || input.length)) {
        const outputChunk = await Promise.all(inputChunk.map(fn));
        output.push(...outputChunk);
    }
    return output;
}
exports.chunkableAsyncMap = chunkableAsyncMap;
//# sourceMappingURL=ChunkableAsyncMap.js.map